// extracted by mini-css-extract-plugin
module.exports = {"main-wrapper":"main_main-wrapper__1WetX"};